






















import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: 'AsideUpdatesItem'
})
export default class AsideUpdatesItem extends Vue {
  @Prop({
    type: String,
    default: null
  })
  icon;

  @Prop({
    type: String,
    default: 'is-info'
  })
  status;

  @Prop({
    type: String,
    default: null
  })
  ago;
}
